


































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView, DxTextArea, DxButton, DxValidator } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import { DxForm, DxItem, DxGroupItem, DxLabel, DxStringLengthRule } from 'devextreme-vue/form';
import { ProjectsClient } from '@/data/web-api-client';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxItem,
    DxGroupItem,
    DxTextArea,
    DxLabel,
    DxStringLengthRule,
    DxButton,
    DxValidator,
  },
})
export default class ConfirmProjectOnHoldDialog extends Vue {
  @Prop({ required: true })
  private projectId!: string;

  @Prop()
  public revert!: boolean;

  showPopup: boolean = false;
  saving: boolean = false;

  private projectsClient = new ProjectsClient(undefined, this.$axios);

  public onHoldModel: {
    projectId: string | undefined;
    onHoldReason: string;
  } = {
    projectId: undefined,
    onHoldReason: '',
  };

  show() {
    this.showPopup = true;
  }

  hide() {
    this.onHoldModel.onHoldReason = '';
    this.showPopup = false;
  }

  mounted() {
    this.onHoldModel.projectId = this.projectId;
  }

  async save() {
    const validationResult = (this.$refs.projectOnHoldForm as DxForm).instance?.validate();

    if (!validationResult?.isValid && validationResult?.brokenRules && validationResult.brokenRules[0] && validationResult.brokenRules[0].message) {
      notificationService.showErrorMessage(validationResult!.brokenRules![0].message!);

      return;
    }

    try {
      this.saving = true;

      await this.projectsClient.toggleProjectOnHold(this.projectId, this.onHoldModel.onHoldReason);

      this.$emit('save');

      this.onHoldModel.onHoldReason = '';
      this.showPopup = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  get validationRules() {
    return [
      {
        type: 'stringLength',
        message: this.$t('objects.projects.OnHoldReasonCharacterLengthMessage'),
        min: 10,
      },
    ];
  }

  get dialogTitle() {
    return this.revert ? this.$t('objects.projects.RevertPutProjectOnHold') : this.$t('objects.projects.PutProjectOnHold');
  }

  get textAreaPlaceholder() {
    return this.revert ? this.$t('objects.projects.RevertOnHoldReasonPlaceHolder') : this.$t('objects.projects.OnHoldReasonPlaceHolder');
  }

  get textAreaLabel() {
    return this.revert ? this.$t('objects.projects.ReasonForRevertProjectOnHold') : this.$t('objects.projects.ReasonForProjectOnHold');
  }

  get buttonText() {
    return this.revert ? this.$t('objects.projects.RevertPutProjectOnHold') : this.$t('objects.projects.PutProjectOnHold');
  }
}
